import { Fragment, useEffect, useState } from 'react';
import { Text } from '../../FormControls/Text';
import { List } from '../../FormControls/List';
import { Stack } from '../../FormControls/Stack';

import { ScreenControl } from '../ScreenControl';
import { useDispatch, useSelector } from 'react-redux';
import { setBankName, retrieveBanks } from '../../../../main/slices/bankSlice';
import { LoadingComponent } from '../../LoadingComponent';

function parseBank(bank){
    let banks = {
        "Banco Industrial": {name: "Banco Industrial", extension: "png"},
        "Banco Promerica": {name: "Banco-Promerica", extension: "jpg"},
        "BAC": {name: "BAC", extension: "png"},
        "BAM": {name: "BAM", extension: "jpg"},
        "Banco G&T Continental": {name: "G&T", extension: "png"},
        "Banrural": {name: "Banrural", extension: "png"} ,
        "Crédito Hipotecario Nacional": {name: "Credito-Hipotecario-Nacional", extension: "jpg"},
        "BANTRAB": {name: "Bantrab", extension: "png"},
        "FICOHSA": {name: "Fichosa", extension: "jpg"},
        "Banco de Occidente": {name: "BancoOccidental", extension: "png"},
        "Banco Davivienda": {name: "Davivienda", extension: "webp"},
        "BANPAIS": {name: "BANPAIS", extension: "svg"},
        "FICENSA": {name: "FICENSA", extension: "jpg"},
        "BANHCAFE": {name: "BANHCAFE", extension: "png"},
        "Banco Atlántida": {name: "Banco Atlántida", extension: "svg"},
        "Banco Lafise": {name: "Banco Lafise", extension: "png"},
        "Banco Azteca": {name: "Banco Azteca", extension: "png"},
        "Banco Azteca": {name: "Banco Azteca", extension: "png"},
        "Banco Hipotecario": {name: "Banco Hipotecario", extension: "png"},
        "Banco Inmobilario": {name: "Banco-Inmobiliario", extension: "png"},
        "Banco Internacional": {name: "Interbanco", extension: "png"},
        "default": {name: "bankdefault", extension: "png"}
    }
    return banks[bank] ? banks[bank] : banks["default"]
}
export const BankSelector = () => {

    const [banks, setBanks] = useState([]);
    const state = useSelector(({ bank }) => bank.bankName);
    const dispatch = useDispatch();

    useEffect(() => {

        dispatch(retrieveBanks()).unwrap().then(({ response }) => {
            setBanks(response.map((b) => ({
                name: b,
                id: b,
                logo: `https://firebasestorage.googleapis.com/v0/b/coincaexchange.appspot.com/o/banks%2F${parseBank(b).name}.${parseBank(b).extension}?alt=media`
            })))
        }).catch((e) => false)

    }, [dispatch]);

    return (
        <Fragment>

            <Stack flex={{ flexDirection: "column" }}>
                <Text classes={["subtitle"]}> Agreguemos tu cuenta bancaria </Text>
                <Text classes={["title"]}> Selecciona un banco </Text>
            </Stack>

            {banks.length ?
                <List
                    items={banks}
                    def={state.value}
                    onSelect={(b) => dispatch(setBankName({ value: b, error: !b }))}
                    keys={{ img: "logo", text: "name", id: "id" }}
                />
                :
                <LoadingComponent />
            }

            <ScreenControl disabled={state.error}></ScreenControl>

        </Fragment>
    )
}